"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _spauiUtils = require("@tencent/spaui-utils");

var _classnames = _interopRequireDefault(require("classnames"));

var _info = _interopRequireDefault(require("./info"));

var _popover = _interopRequireDefault(require("./component/popover"));

var _slider_inner = _interopRequireDefault(require("./component/slider_inner"));

var _step_node = _interopRequireDefault(require("./component/step_node"));

var _prefix = _interopRequireDefault(require("./component/prefix"));

var _suffix = _interopRequireDefault(require("./component/suffix"));

var _index = require("./utils/index");

var _slider_props = require("./slider_props");

var _classname_map = _interopRequireDefault(require("./config/classname_map"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @class
 */
var Slider =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Slider, _PureComponent);

  function Slider(props) {
    var _this;

    _classCallCheck(this, Slider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Slider).call(this, props));
    _this.mouseDown = _this.mouseDown.bind(_assertThisInitialized(_this));
    _this.mouseOver = _this.mouseOver.bind(_assertThisInitialized(_this));
    _this.mouseOut = _this.mouseOut.bind(_assertThisInitialized(_this));
    _this.mouseMove = _this.mouseMove.bind(_assertThisInitialized(_this));
    _this.mouseUp = _this.mouseUp.bind(_assertThisInitialized(_this));
    _this.barClick = _this.barClick.bind(_assertThisInitialized(_this));
    _this.windowResize = _this.windowResize.bind(_assertThisInitialized(_this));
    _this._addStep = _this._addStep.bind(_assertThisInitialized(_this));
    _this._reduceStep = _this._reduceStep.bind(_assertThisInitialized(_this));
    _this.sliderWidth = 0;
    _this.handleWidth = 0;
    _this.handleHeight = 0;
    _this.handleLeftWidth = 0;
    _this.handleLeftHeight = 0;
    _this.handleRightWidth = 0;
    _this.handleRightHeight = 0;
    _this.halfHandleWidth = 0;
    _this.halfHandleLeftWidth = 0;
    _this.halfHandleRightWidth = 0;
    _this.state = _objectSpread({}, (0, _index.getPopOverShowConfig)(props));
    return _this;
  }

  _createClass(Slider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      (0, _index.getDomWidthAndHeight)(this);
      this.forceUpdate();

      if (_index.haveJQuery) {
        jQuery(window).on('resize', this.windowResize);
      } else if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && (0, _spauiUtils.isFunction)(window.addEventListener)) {
        window.addEventListener('resize', this.windowResize);
      }

      setTimeout(function () {
        _this2.windowResize();
      }, 10);

      if ((0, _spauiUtils.isFunction)(_spauiUtils.checkCssVersion)) {
        (0, _spauiUtils.checkCssVersion)(_info["default"]);
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      this.setState(_objectSpread({}, (0, _index.getPopOverShowConfig)(nextProps, this.state)));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.refList();

      if (_index.haveJQuery) {
        jQuery(window).off('resize', this.windowResize);
      } else if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && (0, _spauiUtils.isFunction)(window.addEventListener)) {
        window.removeEventListener('resize', this.windowResize);
      }
    }
  }, {
    key: "refList",
    value: function refList() {
      this.slider = null;
      this.handle = null;
      this.handleLeft = null;
      this.handleRight = null;
      this.handleTargetType = '';
      this.leftPopOver = null;
      this.rightPopOver = null;
      this.singlePopOver = null;
      this.trackValue = '';
      this.trackMouseDown = false;
      this.trackCoordinate = 0;
    }
  }, {
    key: "windowResize",
    value: function windowResize() {
      (0, _index.getDomWidthAndHeight)(this);
      this.forceUpdate();
    }
  }, {
    key: "getClassNameMap",
    value: function getClassNameMap() {
      var _this$props$className = this.props.classNameMap,
          classNameMap = _this$props$className === void 0 ? {} : _this$props$className;
      return _objectSpread({}, _classname_map["default"], {}, classNameMap);
    }
  }, {
    key: "mouseOver",
    value: function mouseOver(event) {
      var _this$props = this.props,
          type = _this$props.type,
          rightPopOver = _this$props.rightPopOver;
      var leftPopOver = (0, _index.getLeftPopOver)(this.props);
      var handle = '';

      if (type === 'range') {
        if (event && event.target && event.target.getAttribute('data-translation')) {
          if (leftPopOver.type === 'hover') {
            this.setState({
              showLeftPopOver: true
            });
          }

          if (rightPopOver.type === 'hover') {
            this.setState({
              showRightPopOver: true
            });
          }
        } else {
          handle = event.target.getAttribute('data-handle') || '';

          switch (handle) {
            case 'left':
              if (leftPopOver.type === 'hover') {
                this.setState({
                  showLeftPopOver: true
                });
              }

              break;

            case 'right':
              if (rightPopOver.type === 'hover') {
                this.setState({
                  showRightPopOver: true
                });
              }

              break;
          }
        }
      } else {
        if (leftPopOver.type === 'hover') {
          this.setState({
            showLeftPopOver: true
          });
        }
      }
    }
  }, {
    key: "mouseOut",
    value: function mouseOut(event) {
      var _this$props2 = this.props,
          type = _this$props2.type,
          rightPopOver = _this$props2.rightPopOver;
      var leftPopOver = (0, _index.getLeftPopOver)(this.props);
      var handle = '';

      if (type === 'range') {
        if (event && event.target && event.target.getAttribute('data-translation')) {
          if (leftPopOver.type === 'hover') {
            this.setState({
              showLeftPopOver: false
            });
          }

          if (rightPopOver.type === 'hover') {
            this.setState({
              showRightPopOver: false
            });
          }
        } else {
          handle = event.target.getAttribute('data-handle') || '';

          switch (handle) {
            case 'left':
              if (leftPopOver.type === 'hover') {
                this.setState({
                  showLeftPopOver: false
                });
              }

              break;

            case 'right':
              if (rightPopOver.type === 'hover') {
                this.setState({
                  showRightPopOver: false
                });
              }

              break;
          }
        }
      } else {
        if (leftPopOver.type === 'hover') {
          this.setState({
            showLeftPopOver: false
          });
        }
      }
    }
    /**
     * 点下鼠标
     * @param {object} event - 事件event对象
     * @return {void}
     * @private
     */

  }, {
    key: "mouseDown",
    value: function mouseDown(event) {
      var _this$props3 = this.props,
          onChangeStart = _this$props3.onChangeStart,
          disabled = _this$props3.disabled,
          type = _this$props3.type,
          rightPopOver = _this$props3.rightPopOver,
          value = _this$props3.value;
      var leftPopOver = (0, _index.getLeftPopOver)(this.props);
      var handle = '';

      if (this.halfHandleWidth < 1) {
        (0, _index.getDomWidthAndHeight)(this);
      }

      if (type === 'range') {
        if (event && event.target && event.target.getAttribute('data-translation')) {
          // 在track按下了
          this.trackValue = (0, _spauiUtils.isArray)(value) ? value.join('-') : '';
          this.trackCoordinate = !event.touches ? event.clientX : event.touches[0].clientX;
          this.trackMouseDown = true;

          if (leftPopOver.type === 'mousedown') {
            this.setState({
              showLeftPopOver: true
            });
          }

          if (rightPopOver.type === 'mousedown') {
            this.setState({
              showRightPopOver: true
            });
          }
        } else {
          handle = event.target.getAttribute('data-handle') || '';

          switch (handle) {
            case 'left':
              if (leftPopOver.type === 'mousedown') {
                this.setState({
                  showLeftPopOver: true
                });
              }

              break;

            case 'right':
              if (rightPopOver.type === 'mousedown') {
                this.setState({
                  showRightPopOver: true
                });
              }

              break;
          }
        }
      } else {
        if (leftPopOver.type === 'mousedown') {
          this.setState({
            showLeftPopOver: true
          });
        }
      }

      if (disabled) {
        return false;
      }

      if ((typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object') {
        document.addEventListener('mousemove', this.mouseMove);
        document.addEventListener('mouseup', this.mouseUp);
      }

      if ((0, _spauiUtils.isFunction)(onChangeStart)) {
        onChangeStart(event);
      }
    }
    /**
     * 鼠标移动
     * @param {object} event - 事件event对象
     * @return {void}
     * @private
     */

  }, {
    key: "mouseMove",
    value: function mouseMove(event) {
      event.stopPropagation();
      event.preventDefault();
      var onChange = this.props.onChange;
      var value = (0, _index.position)(event, '', this);

      if ((0, _spauiUtils.isFunction)(onChange)) {
        onChange(event, value);
      }
    }
    /**
     * 松开鼠标
     * @param {object} event - 事件event对象
     * @return {void}
     * @private
     */

  }, {
    key: "mouseUp",
    value: function mouseUp(event) {
      var _this$props4 = this.props,
          onChangeComplete = _this$props4.onChangeComplete,
          type = _this$props4.type,
          rightPopOver = _this$props4.rightPopOver;
      var leftPopOver = (0, _index.getLeftPopOver)(this.props);
      var value = (0, _index.position)(event, '', this);

      if ((0, _spauiUtils.isFunction)(onChangeComplete)) {
        onChangeComplete(event, value);
      }

      if ((typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object') {
        document.removeEventListener('mousemove', this.mouseMove);
        document.removeEventListener('mouseup', this.mouseUp);
      }

      if (type === 'range') {
        if (leftPopOver.type === 'mousedown') {
          this.setState({
            showLeftPopOver: false
          });
        }

        if (rightPopOver.type === 'mousedown') {
          this.setState({
            showRightPopOver: false
          });
        }
      } else {
        if (leftPopOver.type === 'mousedown') {
          this.setState({
            showLeftPopOver: false
          });
        }
      } // 放开track了


      this.trackMouseDown = false;
      this.trackCoordinate = 0;
      this.trackValue = '';
    }
  }, {
    key: "_getValue",
    value: function _getValue() {
      var _this$props5 = this.props,
          value = _this$props5.value,
          type = _this$props5.type;
      var result = '';
      var leftValue = 0;
      var rightValue = 0;

      if (type === 'range') {
        if ((0, _spauiUtils.isArray)(value)) {
          leftValue = value[0] || 0;
          rightValue = value[1] || 0;

          if (leftValue > rightValue) {
            result = [rightValue, leftValue];
          } else {
            result = [leftValue, rightValue];
          }
        } else {
          result = [leftValue, rightValue];
        }
      } else {
        result = value;
      }

      return result;
    }
    /**
     * 直接点击某个位置改值
     * @param {object} event - 事件event对象
     * @return {void}
     * @private
     */

  }, {
    key: "barClick",
    value: function barClick(event) {
      var _this$props6 = this.props,
          onChange = _this$props6.onChange,
          onChangeComplete = _this$props6.onChangeComplete,
          disabled = _this$props6.disabled,
          type = _this$props6.type;

      var value = this._getValue();

      var result = 0;
      var leftValue = 0;
      var rightValue = 0;
      var tempValue = 0;
      var barValue = 0;

      if (disabled) {
        return false;
      }

      if (this.halfHandleWidth < 1) {
        (0, _index.getDomWidthAndHeight)(this);
      }

      barValue = (0, _index.position)(event, 'click', this);

      if (type === 'range') {
        leftValue = value[0] || 0;
        rightValue = value[1] || 0;

        if (leftValue > rightValue) {
          tempValue = leftValue;
          leftValue = rightValue;
          rightValue = tempValue;
        }

        if (barValue < leftValue || barValue > leftValue && barValue < rightValue) {
          result = [barValue, rightValue];
        } else if (barValue > rightValue) {
          result = [leftValue, barValue];
        } else {
          result = value;
        }
      } else {
        result = barValue;
      }

      if ((0, _spauiUtils.isFunction)(onChange)) {
        onChange(event, result);
      }

      if ((0, _spauiUtils.isFunction)(onChangeComplete)) {
        onChangeComplete(event, result);
      }
    }
  }, {
    key: "_addStep",
    value: function _addStep(event) {
      var _this$props7 = this.props,
          type = _this$props7.type,
          value = _this$props7.value,
          max = _this$props7.max,
          onChange = _this$props7.onChange,
          onChangeComplete = _this$props7.onChangeComplete,
          disabled = _this$props7.disabled,
          step = _this$props7.step,
          valueNodes = _this$props7.valueNodes;
      var result = value;
      var startValue = 0;
      var endValue = 0;
      var valueIndex = -1;

      if (disabled) {
        return false;
      }

      if (type === 'range') {
        startValue = result[0] || 0;
        endValue = result[1] || 0;

        if (valueNodes.length < 1) {
          if (endValue < max && endValue + step <= max) {
            endValue = endValue + step;
          }
        } else {
          valueIndex = (0, _spauiUtils.indexOf)(valueNodes, endValue);

          if (valueIndex > -1 && valueIndex < valueNodes.length - 1) {
            endValue = valueNodes[valueIndex + 1];
          } else if (valueIndex < 0) {
            endValue = valueNodes[0];
          }
        }

        result = [startValue, endValue];
      } else {
        if (valueNodes.length < 1) {
          if (value < max && value + step <= max) {
            result = value + step;
          }
        } else {
          valueIndex = (0, _spauiUtils.indexOf)(valueNodes, value);

          if (valueIndex > -1 && valueIndex < valueNodes.length - 1) {
            result = valueNodes[valueIndex + 1];
          } else if (valueIndex < 0) {
            result = valueNodes[0];
          }
        }
      }

      if ((0, _spauiUtils.isFunction)(onChange)) {
        onChange(event, result);
      }

      if ((0, _spauiUtils.isFunction)(onChangeComplete)) {
        onChangeComplete(event, result);
      }
    }
  }, {
    key: "_reduceStep",
    value: function _reduceStep(event) {
      var _this$props8 = this.props,
          type = _this$props8.type,
          value = _this$props8.value,
          min = _this$props8.min,
          onChange = _this$props8.onChange,
          onChangeComplete = _this$props8.onChangeComplete,
          disabled = _this$props8.disabled,
          step = _this$props8.step,
          _this$props8$valueNod = _this$props8.valueNodes,
          valueNodes = _this$props8$valueNod === void 0 ? [] : _this$props8$valueNod;
      var result = value;
      var startValue = 0;
      var endValue = 0;
      var valueIndex = -1;

      if (disabled) {
        return false;
      }

      if (type === 'range') {
        startValue = result[0] || 0;
        endValue = result[1] || 0;

        if (valueNodes.length < 1) {
          if (startValue > min && startValue + step >= min) {
            startValue = startValue - step;
          }
        } else {
          valueIndex = (0, _spauiUtils.indexOf)(valueNodes, startValue);

          if (valueIndex > -1 && valueIndex > 0) {
            startValue = valueNodes[valueIndex - 1];
          } else if (valueIndex < 0) {
            startValue = valueNodes[0];
          }
        }

        result = [startValue, endValue];
      } else {
        if (valueNodes.length < 1) {
          if (value > min && value + step >= min) {
            result = value - step;
          }
        } else {
          valueIndex = (0, _spauiUtils.indexOf)(valueNodes, value);

          if (valueIndex > -1 && valueIndex > 0) {
            result = valueNodes[valueIndex - 1];
          } else if (valueIndex < 0) {
            result = valueNodes[0];
          }
        }
      }

      if ((0, _spauiUtils.isFunction)(onChange)) {
        onChange(event, result);
      }

      if ((0, _spauiUtils.isFunction)(onChangeComplete)) {
        onChangeComplete(event, result);
      }
    }
  }, {
    key: "removePopOver",
    value: function removePopOver() {
      if (this.leftPopOver) {
        this.leftPopOver._removeNode();
      }

      if (this.rightPopOver) {
        this.rightPopOver._removeNode();
      }

      if (this.singlePopOver) {
        this.singlePopOver._removeNode();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames,
          _this3 = this;

      var _this$props9 = this.props,
          infoContent = _this$props9.infoContent,
          disabled = _this$props9.disabled,
          type = _this$props9.type,
          rightPopOver = _this$props9.rightPopOver,
          prefix = _this$props9.prefix,
          suffix = _this$props9.suffix,
          min = _this$props9.min,
          max = _this$props9.max,
          showStepButton = _this$props9.showStepButton,
          stepNodePlacement = _this$props9.stepNodePlacement,
          setStepNodeLabel = _this$props9.setStepNodeLabel,
          size = _this$props9.size,
          showStepNode = _this$props9.showStepNode,
          stepNodes = _this$props9.stepNodes,
          SliderTrack = _this$props9.SliderTrack,
          canTranslationRange = _this$props9.canTranslationRange,
          SliderHandle = _this$props9.SliderHandle,
          valueNodes = _this$props9.valueNodes;
      var leftPopOver = (0, _index.getLeftPopOver)(this.props);
      var _this$state = this.state,
          showLeftPopOver = _this$state.showLeftPopOver,
          showRightPopOver = _this$state.showRightPopOver;

      var value = this._getValue();

      var _getStyleByValue = (0, _index.getStyleByValue)(value, this),
          shouldShow = _getStyleByValue.shouldShow,
          trackWidth = _getStyleByValue.trackWidth,
          trackLeft = _getStyleByValue.trackLeft,
          handleLeft = _getStyleByValue.handleLeft,
          handleRight = _getStyleByValue.handleRight;

      var classNameMap = this.getClassNameMap();

      var stepNodeDom = _react["default"].createElement(_step_node["default"], {
        classNameMap: classNameMap,
        showStepNode: showStepNode,
        stepNodes: stepNodes,
        valueNodes: valueNodes,
        min: min,
        max: max,
        setStepNodeLabel: setStepNodeLabel,
        sliderWidth: this.slider && this.sliderWidth
      });

      var customClassName = (0, _classnames["default"])(classNameMap.Slider, (_classNames = {
        disabled: disabled
      }, _defineProperty(_classNames, classNameMap.SliderWithFixClassName, prefix || suffix || showStepButton), _defineProperty(_classNames, classNameMap.SliderWithStepClassName, showStepButton), _defineProperty(_classNames, classNameMap.SliderStepTopClassName, stepNodePlacement === 'top'), _defineProperty(_classNames, classNameMap.SliderShowStepNodeClassName, showStepNode && stepNodes.length > 0 && !infoContent), _classNames), {
        'size-xlg': size === 'extralarge',
        'size-sm': size === 'small',
        'size-lg': size === 'large'
      });
      var result = null;
      var trackStyle = {
        width: 0
      };
      var handleStyle = {};
      var handleLeftStyle = {};
      var handleRightStyle = {};
      var leftPopOverStyle = {};
      var rightPopOverStyle = {};
      var sliderInnerDom = null;
      var sliderTrackProps = {};

      if (shouldShow) {
        trackStyle.width = trackWidth;
        trackStyle.marginLeft = trackLeft;
        handleStyle.left = handleLeft;
        handleLeftStyle.left = handleLeft;
        handleRightStyle.left = handleRight;
        leftPopOverStyle.left = handleLeft;
        rightPopOverStyle.left = handleRight;
      }

      if (!canTranslationRange) {
        sliderTrackProps = {
          onMouseDown: this.barClick
        };
      } else {
        sliderTrackProps = {
          onMouseDown: this.mouseDown,
          onMouseOut: this.mouseOut,
          onMouseOver: this.mouseOver
        };
      }

      sliderInnerDom = _react["default"].createElement(_slider_inner["default"], _extends({}, this.props, {
        classNameMap: classNameMap,
        htmlRef: function htmlRef(ele) {
          _this3.slider = ele;
        },
        onBarClick: this.barClick,
        onMouseDown: this.barClick,
        style: trackStyle,
        SliderTrack: SliderTrack,
        sliderTrackProps: sliderTrackProps
      }));

      if (type === 'range') {
        result = _react["default"].createElement("div", {
          className: classNameMap.SliderClassName
        }, stepNodePlacement === 'top' ? stepNodeDom : null, sliderInnerDom, _react["default"].createElement(SliderHandle, {
          className: (0, _classnames["default"])(classNameMap.SliderHandleClassName, classNameMap.SliderLeftHandleClassName),
          htmlRef: function htmlRef(ele) {
            _this3.handleLeft = ele;
          },
          type: "left",
          onMouseDown: this.mouseDown,
          onMouseOver: this.mouseOver,
          onMouseOut: this.mouseOut,
          style: handleLeftStyle
        }), _react["default"].createElement(SliderHandle, {
          className: (0, _classnames["default"])(classNameMap.SliderHandleClassName, classNameMap.SliderRightHandleClassName),
          htmlRef: function htmlRef(ele) {
            _this3.handleRight = ele;
          },
          type: "right",
          onMouseDown: this.mouseDown,
          onMouseOver: this.mouseOver,
          onMouseOut: this.mouseOut,
          style: handleRightStyle
        }), stepNodePlacement !== 'top' ? stepNodeDom : null, _react["default"].createElement(_popover["default"], {
          ref: function ref(el) {
            _this3.leftPopOver = el;
          },
          show: showLeftPopOver,
          target: this.slider,
          targetRect: this.slider ? this.slider.getBoundingClientRect() : {},
          style: leftPopOverStyle,
          className: leftPopOver.className || '',
          placement: leftPopOver.placement || '',
          offsetData: leftPopOver.offsetData || {},
          classNameMap: classNameMap
        }, leftPopOver.msg), _react["default"].createElement(_popover["default"], {
          ref: function ref(el) {
            _this3.rightPopOver = el;
          },
          show: showRightPopOver,
          target: this.slider,
          targetRect: this.slider ? this.slider.getBoundingClientRect() : {},
          style: rightPopOverStyle,
          className: rightPopOver.className || '',
          placement: rightPopOver.placement || '',
          offsetData: rightPopOver.offsetData || {},
          classNameMap: classNameMap
        }, rightPopOver.msg));
      } else {
        result = _react["default"].createElement("div", {
          className: classNameMap.SliderClassName
        }, stepNodePlacement === 'top' ? stepNodeDom : null, sliderInnerDom, _react["default"].createElement(SliderHandle, {
          className: (0, _classnames["default"])(classNameMap.SliderHandleClassName),
          htmlRef: function htmlRef(ele) {
            _this3.handle = ele;
          },
          onMouseDown: this.mouseDown,
          onMouseOver: this.mouseOver,
          onMouseOut: this.mouseOut,
          style: handleStyle
        }), stepNodePlacement !== 'top' ? stepNodeDom : null, _react["default"].createElement(_popover["default"], {
          ref: function ref(el) {
            _this3.singlePopOver = el;
          },
          show: showLeftPopOver,
          target: this.slider,
          targetRect: this.slider ? this.slider.getBoundingClientRect() : {},
          style: leftPopOverStyle,
          className: leftPopOver.className || '',
          placement: leftPopOver.placement || '',
          offsetData: leftPopOver.offsetData || {},
          classNameMap: classNameMap
        }, leftPopOver.msg));
      }

      return _react["default"].createElement("div", (0, _spauiUtils.globalProps)(this.props, {
        className: customClassName
      }, Slider, this.props), _react["default"].createElement(_prefix["default"], {
        classNameMap: classNameMap,
        showStepButton: showStepButton,
        prefix: prefix,
        onClick: this._reduceStep
      }), result, _react["default"].createElement(_suffix["default"], {
        classNameMap: classNameMap,
        showStepButton: showStepButton,
        suffix: suffix,
        onClick: this._addStep
      }), infoContent ? _react["default"].createElement("p", {
        className: classNameMap.SliderInfoClassName
      }, infoContent) : null);
    }
  }]);

  return Slider;
}(_react.PureComponent); // 组件标记


_defineProperty(Slider, "propTypes", _slider_props.propTypes);

_defineProperty(Slider, "defaultProps", _slider_props.defaultProps);

(0, _spauiUtils.setComponentMark)(Slider, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"])); // 用于 focus 样式只在键盘索引时生效，而在鼠标操作时不生效

(0, _spauiUtils.initFocusManager)('spaui-focus-disabled');
var _default = Slider;
exports["default"] = _default;